// Update an item in an array or add it if it doesn't exist.
export const updateOrAppendItem = <T extends { id: number | string }>({
  array,
  data,
}: {
  array: T[];
  data: T;
}): void => {
  const index = array.findIndex(({ id }) => id === data.id);

  if (index !== -1) {
    array[index] = { ...array[index], ...data };
  } else {
    array.push(data);
  }
};
